import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { TariffDimensionType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';
import { useTariffContext } from '@app/feature/tariff/tariff.context';

export const FlatCardComponent = (): React.JSX.Element => {
  const { t } = useTranslation();

  const tariff = useTariffContext();

  const flatValue = useMemo(() => {
    const firstElement = tariff.elements[0];
    const flatPriceComponent = firstElement?.priceComponents.find(
      (p) => p.type === TariffDimensionType.FLAT,
    );
    if (flatPriceComponent) {
      return flatPriceComponent.price;
    }

    return undefined;
  }, [tariff]);

  const description = useMemo(() => {
    if (!tariff.tariffAltText) {
      return undefined;
    }

    const concatenatedText = tariff.tariffAltText
      ?.reduce((acc: string[], text) => {
        if (i18n.language.startsWith(text.language)) {
          acc.push(text.text);
        }
        return acc;
      }, [])
      .join(', ');

    return concatenatedText !== '' ? concatenatedText : undefined;
  }, [tariff]);

  return (
    <Card gap={GapEnum.M} direction="column">
      <Stack gap={GapEnum.M} justifyContent="space-between" alignItems="center">
        <AccentTitle
          icon="home-03"
          text={t('$.tariff-details.flat.title')}
          as={HeadingEnum.H2}
          variant={AccentVariantEnum.Secondary}
        />

        <Text bold>
          {flatValue !== undefined &&
            toCurrencyString(flatValue, tariff.currency)}
        </Text>
      </Stack>

      {description && (
        <Stack gap={GapEnum.S} direction="column">
          <Text bold>
            {t('delmonicos-shared-sdk.outputs-tariff.tariff-alt-text')}
          </Text>
          <Text>{description}</Text>
        </Stack>
      )}
    </Card>
  );
};
